export const LANGUAGES = [
  { label: '中國人 (Traditional)', code: 'zh-TW', symbol: '繁體' },
  { label: '中国人 (Simplified)', code: 'zh-CN', symbol: '简体' },
  { label: 'English', code: 'en', symbol: 'EN' },
];
